import { Input } from 'antd';
import AddressesTableHeader from 'components/common/tables_header/addresses';
import PhoneTableHeader from 'components/common/tables_header/phone';
import StatusTableHeader from 'components/common/tables_header/status_header';
import { CustomDatePicker, CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import AddressesTable from 'components/tables/addresses';
import ChildrenTable from 'components/tables/children_tables';
import PhonesTable from 'components/tables/phones';
import dayjs from 'dayjs';
import { FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import { marriedStatus } from 'utils';

type CivilStatusProps = {
  countries?: any;
  nationality?: any;
  user?: any;
  onUpdateData?: (data: object) => void;
  formik?: FormikProps<any>;
};

const CivilStatus = ({
  countries,
  nationality,
  user,
  onUpdateData,
  formik,
}: CivilStatusProps) => {
  const [state, setState] = useState({
    addChildren: false,
    addPhones: false,
    addAddress: false,
    data: user,
  });

  const onClose = () => {
    setState((pre) => ({
      ...pre,
      addChildren: false,
    }));
  };

  const onClosePhones = () => {
    setState((pre) => ({
      ...pre,
      addPhones: false,
    }));
  };
  const onCloseAddress = () => {
    setState((pre) => ({
      ...pre,
      addAddress: false,
    }));
  };

  const { addChildren, addPhones, addAddress, data } = state;
  useEffect(() => {
    setState((pre) => ({
      ...pre,
      addPhones: false,
      addAddress: false,
      addChildren: false,
      data: user,
    }));
  }, [user, formik?.submitCount]);

  return (
    <div>
      <h1
        style={{
          fontWeight: 500,
          fontSize: 20,
          paddingBottom: 40,
          color: '#000000',
        }}
      >
        Civil Status
      </h1>
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridColumn: 1,
          gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
          gap: '32px',
        }}
      >
        <CustomInput
          value={formik?.values?.social_security_number}
          title={'Social Security Number'}
          required={user?.role !== 'admin'}
          fontSize={12}
          errors={formik.errors}
          height="50px"
          name="social_security_number"
          width={'100%'}
          onChange={formik.handleChange}
        />
        <div
          style={{
            width: '100%',
          }}
        >
          <CustomDropdown
            defaultKey={formik?.values?.nationality}
            title="Nationality"
            options={nationality}
            fontSize={12}
            height="50px"
            defaultBorder="6px"
            value={formik?.values?.nationality}
            width="100%"
            onSelect={(v: string) => {
              if (v) {
                formik.setFieldValue('nationality', v);
              }
            }}
          />
        </div>
        <CustomInput
          value={formik?.values?.birth_name}
          title={'Birth Name'}
          name="birth_name"
          required={user?.role !== 'admin'}
          fontSize={12}
          errors={formik.errors}
          height="50px"
          width={'100%'}
          onChange={formik.handleChange}
        />
      </div>
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridColumn: 1,
          gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
          gap: '32px',
          marginTop: 32,
        }}
      >
        <div style={{ width: '100%' }} className="show_item_date">
          <CustomDatePicker
            disabledDate={(current) => {
              let customDate = dayjs().format('YYYY-MM-DD');
              return current && current > dayjs(customDate, 'YYYY-MM-DD');
            }}
            value={
              formik?.values?.date_of_birth &&
              dayjs(formik?.values?.date_of_birth)
              // : dayjs()
            }
            // errors={formik.errors}
            height={50}
            fontSize={12}
            borderRadius={6}
            onChange={(e) => {
              onUpdateData?.({ date_of_birth: e?.format('YYYY-MM-DD') });
              formik.setFieldValue('date_of_birth', e?.format('YYYY-MM-DD'));
            }}
            width="100%"
            title="Date of birth"
          />
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            width: '100%',
          }}
        >
          <CustomInput
            value={formik?.values?.birth_city}
            title={'City of Birth'}
            name="birth_city"
            height="50px"
            errors={formik.errors}
            fontSize="12px"
            width={'50%'}
            required={user?.role !== 'admin'}
            onChange={formik?.handleChange}
          />
          <CustomInput
            value={formik?.values?.birth_department}
            title={'Birth Departent Number'}
            name="birth_department"
            height="50px"
            fontSize="12px"
            width={'50%'}
            onChange={formik?.handleChange}
          />
        </div>
        <CustomDropdown
          defaultKey={formik?.values?.birth_country}
          title="Country of Birth"
          options={countries}
          height="50px"
          fontSize="12px"
          defaultBorder="6px"
          // errors={formik.errors}
          width="100%"
          onSelect={(v: string) => {
            if (v) {
              formik?.setFieldValue('birth_country', v);
            }
          }}
        />
      </div>
      <div style={{ width: '32%', marginTop: 32 }}>
        <CustomDropdown
          title="Marital Status"
          options={marriedStatus}
          height="50px"
          fontSize="12px"
          width="100%"
          defaultBorder="6px"
          defaultKey={formik?.values?.marital_status}
          onSelect={(v: string) => {
            if (v) {
              formik.setFieldValue('marital_status', v);
            }
          }}
        />
      </div>
      <h2
        style={{
          marginTop: '30px',
          fontWeight: 500,
          fontSize: 16,
          color: '#000000',
        }}
      >
        Children and Dependents
      </h2>
      <div
        onClick={() => setState((pre) => ({ ...pre, addChildren: true }))}
        className="add_user_second_step_button"
      >
        <img src="/icons/new_button.svg" alt="button" />
        Add item
      </div>
      <div
        className="employee_directory_filter_table"
        style={{ width: '100%', marginTop: '30px' }}
      >
        <StatusTableHeader />
        <ChildrenTable
          data={
            formik?.values.children_dependents &&
            formik?.values.children_dependents
          }
          addChildren={addChildren}
          onClose={onClose}
          parentFormik={formik}
        />
      </div>
      {/* PHONES//////////////////////////// */}
      <h2
        style={{
          marginTop: '30px',
          fontWeight: 500,
          fontSize: 20,
          color: '#000000',
        }}
      >
        Contact Details
      </h2>
      <div style={{ marginTop: '30px' }}>
        <h2 style={{ fontWeight: 500, fontSize: 16, color: '#000000' }}>
          Phones
        </h2>
        <div
          onClick={() => setState((pre) => ({ ...pre, addPhones: true }))}
          className="add_user_second_step_button"
        >
          <img src="/icons/new_button.svg" alt="button" />
          Add item
        </div>
        {/* TABLE */}
        <div
          className="employee_directory_filter_table"
          style={{ width: '60%', marginTop: '30px' }}
        >
          <PhoneTableHeader />
          <PhonesTable
            data={formik.values?.phones}
            onClose={onClosePhones}
            addPhones={addPhones}
            parentFormik={formik}
          />
        </div>
      </div>
      <div style={{ marginTop: '30px' }}>
        <h2 style={{ fontWeight: 500, fontSize: 16, color: '#000000' }}>
          Addresses
        </h2>
        <div
          onClick={() => setState((pre) => ({ ...pre, addAddress: true }))}
          className="add_user_second_step_button"
        >
          <img src="/icons/new_button.svg" alt="button" />
          Add item
        </div>
        {/* TABLE */}
        <div
          className="employee_directory_filter_table"
          style={{ width: '100%', marginTop: '30px' }}
        >
          <AddressesTableHeader />
          <AddressesTable
            countries={countries}
            onClose={onCloseAddress}
            addAddress={addAddress}
            data={formik && formik?.values?.addresses}
            parentFormik={formik}
          />
        </div>
      </div>
      <div style={{ marginTop: '32px' }}>
        <CustomInput
          value={formik?.values?.personal_email}
          title={'Personal Email'}
          name="personal_email"
          maxLength={50}
          height="50px"
          fontSize={12}
          errors={formik.errors}
          width={'100%'}
          onChange={formik.handleChange}
        />
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '24px',
          marginTop: '32px',
          height: 50,
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: 8,
            width: '25%',
          }}
        >
          <div
            style={{
              width: '100%',
              borderRadius: '6px',
            }}
            className="add_user_third_step_full_input"
          >
            <div
              className="add_user_third_step_label"
              style={{ lineHeight: '12px' }}
            >
              LinkedIn
            </div>
            <Input
              onChange={formik.handleChange}
              value={formik.values?.linkedin}
              name="linkedin"
              bordered={false}
              style={{
                paddingLeft: 0,
                fontSize: '12px',
              }}
              maxLength={100}
              placeholder="linkedin.com/in/user"
              className="add_user_third_step_input"
            />
          </div>
          <img
            src="/icons/linkedin.svg"
            width={35}
            height={35}
            alt="linkedin"
          />
        </div>
        <div style={{ width: '25%', display: 'flex', gap: 8 }}>
          <div
            style={{
              width: '100%',
              borderRadius: '6px',
            }}
            className="add_user_third_step_full_input"
          >
            <div
              className="add_user_third_step_label"
              style={{ lineHeight: '12px' }}
            >
              Viadeo
            </div>
            <Input
              value={formik.values?.viadeo}
              placeholder="viadeo.com/en/profile/user"
              className="add_user_third_step_input"
              name="viadeo"
              style={{
                paddingLeft: 0,
                fontSize: '12px',
              }}
              maxLength={100}
              bordered={false}
              onChange={formik.handleChange}
            />
          </div>
          <img src="/icons/vladeo.svg" width={35} height={35} alt="vladeo" />
        </div>
        <div
          style={{
            display: 'flex',
            gap: 8,
            width: '25%',
          }}
        >
          <div
            style={{
              width: '100%',
              borderRadius: '6px',
            }}
            className="add_user_third_step_full_input"
          >
            <div
              className="add_user_third_step_label"
              style={{ lineHeight: '12px' }}
            >
              Twitter
            </div>
            <Input
              value={formik.values?.twitter}
              placeholder="twitter.com/user"
              name="twitter"
              bordered={false}
              style={{
                paddingLeft: 0,
                fontSize: '12px',
              }}
              className="add_user_third_step_input"
              onChange={formik.handleChange}
            />
          </div>
          <img src="/icons/twitter.svg" width={35} height={35} alt="twitter" />
        </div>
        <div
          style={{
            display: 'flex',
            gap: 8,
            width: '25%',
          }}
        >
          <div
            style={{
              width: '100%',
              borderRadius: '6px',
            }}
            className="add_user_third_step_full_input"
          >
            <div
              className="add_user_third_step_label"
              style={{ lineHeight: '12px' }}
            >
              Facebook
            </div>
            <Input
              value={formik.values?.facebook}
              placeholder="facebook.com/user"
              name="facebook"
              style={{
                paddingLeft: 0,
                fontSize: '12px',
              }}
              bordered={false}
              className="add_user_third_step_input"
              onChange={formik.handleChange}
            />
          </div>
          <img
            src="/icons/facebook.svg"
            width={35}
            height={35}
            alt="facebook"
          />
        </div>
      </div>
    </div>
  );
};

export default CivilStatus;
